export default __webpack_public_path__ + "static/media/train.4ce73bb2.svg";